import { faList } from '@fortawesome/pro-solid-svg-icons/faList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Membership } from '@spike/membership-model';
import { FunctionComponent, MouseEvent, useState } from 'react';
import MembershipDetailsModal from '../Detail/MembershipDetailsModal';

export interface DetailsProps {
    membership?: Membership;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            borderBottom: '2px solid black',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            paddingBottom: 5
        },
        text: {
            fontSize: 14,
            fontWeight: 600,
            marginLeft: 5
        }
    })
);

export const Details: FunctionComponent<DetailsProps> = props => {
    const classes = useStyles(props);

    const [showModal, setShowModal] = useState(false);

    const clickHandler = (event: MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        props.membership && setShowModal(true);
    };

    const modal = props.membership ? (
        <MembershipDetailsModal
            membership={props.membership}
            open={showModal}
            onClose={() => setShowModal(false)}
        />
    ) : null;

    return (
        <>
            <Box
                className={classes.container}
                onClick={clickHandler}
            >
                <FontAwesomeIcon icon={faList} />
                <Typography className={classes.text}>Details</Typography>
            </Box>
            {props.membership ? (
                <MembershipDetailsModal
                    membership={props.membership}
                    open={showModal}
                    onClose={() => setShowModal(false)}
                />
            ) : null}
        </>
    );
};

export default Details;
